// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const AllLenses = (): ReactElement => (
    <FormattedMessage
        id="apps.shared.components.lensSearch.allLenses"
        description="All lenses."
        defaultMessage="All Lenses"
    />
);
AllLenses.displayName = "AllLenses";
